import * as React from 'react';
import type { SVGProps } from 'react';
const Minimize2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"
    />
  </svg>
);
export default Minimize2;
